var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiptLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2513_4109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2513_4109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 18.3346C4.30556 18.3346 3.71528 18.0916 3.22917 17.6055C2.74306 17.1194 2.5 16.5291 2.5 15.8346V13.3346H5V1.66797L6.25 2.91797L7.5 1.66797L8.75 2.91797L10 1.66797L11.25 2.91797L12.5 1.66797L13.75 2.91797L15 1.66797L16.25 2.91797L17.5 1.66797V15.8346C17.5 16.5291 17.2569 17.1194 16.7708 17.6055C16.2847 18.0916 15.6944 18.3346 15 18.3346H5ZM15 16.668C15.2361 16.668 15.434 16.5881 15.5938 16.4284C15.7535 16.2687 15.8333 16.0707 15.8333 15.8346V4.16797H6.66667V13.3346H14.1667V15.8346C14.1667 16.0707 14.2465 16.2687 14.4063 16.4284C14.566 16.5881 14.7639 16.668 15 16.668ZM7.5 7.5013V5.83464H12.5V7.5013H7.5ZM7.5 10.0013V8.33464H12.5V10.0013H7.5ZM14.1667 7.5013C13.9306 7.5013 13.7326 7.42144 13.5729 7.26172C13.4132 7.102 13.3333 6.90408 13.3333 6.66797C13.3333 6.43186 13.4132 6.23394 13.5729 6.07422C13.7326 5.9145 13.9306 5.83464 14.1667 5.83464C14.4028 5.83464 14.6007 5.9145 14.7604 6.07422C14.9201 6.23394 15 6.43186 15 6.66797C15 6.90408 14.9201 7.102 14.7604 7.26172C14.6007 7.42144 14.4028 7.5013 14.1667 7.5013ZM14.1667 10.0013C13.9306 10.0013 13.7326 9.92144 13.5729 9.76172C13.4132 9.602 13.3333 9.40408 13.3333 9.16797C13.3333 8.93186 13.4132 8.73394 13.5729 8.57422C13.7326 8.4145 13.9306 8.33464 14.1667 8.33464C14.4028 8.33464 14.6007 8.4145 14.7604 8.57422C14.9201 8.73394 15 8.93186 15 9.16797C15 9.40408 14.9201 9.602 14.7604 9.76172C14.6007 9.92144 14.4028 10.0013 14.1667 10.0013ZM5 16.668H12.5V15.0013H4.16667V15.8346C4.16667 16.0707 4.24653 16.2687 4.40625 16.4284C4.56597 16.5881 4.76389 16.668 5 16.668Z",
    fill: "#DADADA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptLong);
export default __webpack_public_path__ + "static/media/receipt_long.c83c2a06d6a47bb63392614fd1d45dcb.svg";
export { ForwardRef as ReactComponent };